import {useState, useEffect} from 'react';

export const ORIENTATIONS = {
    portrait: 'portrait',
    landscape: 'landscape'
}

const getOrientation = () => {
    if (window.screen?.orientation?.type) {
        switch (window.screen.orientation.type) {
            case 'portrait-primary':
            case 'portrait-secondary':
                return ORIENTATIONS.portrait;
            case 'landscape-primary':
            case 'landscape-secondary':
                return ORIENTATIONS.landscape;
            default:
                return ORIENTATIONS.portrait;
        }
    }

    if (window.orientation) {
        switch (window.orientation) {
            case -90:
            case 90:
                return ORIENTATIONS.landscape;
            default:
                return ORIENTATIONS.portrait;
        }
    }

    return window.innerHeight > window.innerWidth ? ORIENTATIONS.portrait : ORIENTATIONS.landscape;
}

export const useScreenOrientation = () => {
    const [orientation, setOrientation] = useState(getOrientation());

    const updateOrientation = () => {
        setOrientation(getOrientation());
    }

    useEffect(() => {
        window.addEventListener('orientationchange', updateOrientation);

        return () => window.removeEventListener('orientationchange', updateOrientation);
    }, []);

    const isOrientationPortrain = orientation === ORIENTATIONS.portrait;
    const isOrientationLandscape = orientation === ORIENTATIONS.landscape;

  return {orientation, isOrientationPortrain, isOrientationLandscape};
}
